import React, { ReactElement } from 'react';
import { NotFoundPage } from 'slovlex-idsk-react-components';
import SecuredPageComponent from './component/SecuredPageComponent';
import { useUserContext } from '../../context/UserContext';
import UserRole from '../../model/currentuser/UserRole';
import SecuredPageErrorConditions from '../../model/SecuredPageErrorConditions';
import Layout from '../../page/Layout';
import { ForbiddenPage } from '../../page';

interface Props {
  children: ReactElement;
  allowForRoles?: Array<UserRole>;
  requestStatuses?: Array<number>;
  errorPageConditions?: SecuredPageErrorConditions;
}

const SecuredPage = ({
  children,
  allowForRoles,
  requestStatuses,
  errorPageConditions,
}: Props): ReactElement => {
  const {
    pouzivatel,
    legislationProcess,
  } = useUserContext();

  if (requestStatuses?.includes(403)) {
    return <ForbiddenPage />;
  }

  if (pouzivatel && !legislationProcess) {
    return (
      <Layout withoutNavLinks>
        <NotFoundPage />
      </Layout>
    );
  }

  if (requestStatuses?.includes(404)) {
    return <NotFoundPage />;
  }

  return (
    <SecuredPageComponent
      pouzivatel={pouzivatel}
      allowForRoles={allowForRoles}
      legislationProcess={legislationProcess}
      errorPageConditions={errorPageConditions}
    >
      {children}
    </SecuredPageComponent>
  );
};

export default SecuredPage;
